import { apiFetch } from './client';
export async function createSegment(projectId, payload) {
    return apiFetch(`/projects/${projectId}/segments`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}
export async function patchSegment(segmentId, payload) {
    return apiFetch(`/segments/${segmentId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    });
}
export async function deleteSegment(segmentId) {
    await apiFetch(`/segments/${segmentId}`, { method: 'DELETE' });
}
